import { Component, effect, input, output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListboxChangeEvent, ListboxModule } from 'primeng/listbox';
import { Popover } from 'primeng/popover';
import { PrimeTemplate } from 'primeng/api';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { translationSchema } from '@well/translation';
import { DelEmployeeVoModel } from '@well/delivery-libs/employee/domain';
import { BsListboxComponent } from 'iriro-frontend-libs/bs-component-store';
@Component({
  selector: ' well-employee-selection-overlay-panel',
  standalone: true,
  imports: [
    CommonModule,
    ListboxModule,
    Popover,
    PrimeTemplate,
    ReactiveFormsModule,
    TranslateModule,
    Popover,
    BsListboxComponent,
  ],
  templateUrl: './employee-selection-overlay-panel.component.html',
  styleUrl: './employee-selection-overlay-panel.component.scss',
})
export class EmployeeSelectionOverlayPanelComponent {
  protected readonly translationSchema = translationSchema;

  @ViewChild('op') op!: Popover;

  toggleEvent = input<MouseEvent | null>();
  originalSuggestions = input<DelEmployeeVoModel[]>([]);
  form = input<FormGroup>();
  onSelectEmployee = output<ListboxChangeEvent>();

  constructor() {
    effect(() => {
      if (this.toggleEvent()) {
        this.op.toggle(this.toggleEvent());
      } else {
        this.op.hide();
      }
    });
  }
}
